// Simple pub/sub for media audio ducking: TVDisplay calls start()/end() around
// SpeechSynthesis utterances, and MediaZone subscribes to mute YouTube/MP4
// during the announcement so the TTS voice stays audible.

const listeners = new Set();
let active = 0;

export const subscribeDuck = (fn) => {
  listeners.add(fn);
  // Sync initial state if a speech is already in progress
  if (active > 0) fn(true);
  return () => listeners.delete(fn);
};

const notify = (ducked) => {
  listeners.forEach((fn) => {
    try {
      fn(ducked);
    } catch {
      /* ignore */
    }
  });
};

export const startDuck = () => {
  active += 1;
  if (active === 1) notify(true);
};

export const endDuck = () => {
  active = Math.max(0, active - 1);
  if (active === 0) notify(false);
};

// Safety: hard reset on visibility change (avoid stuck-ducked state if utterance is interrupted)
if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden" && active > 0) {
      active = 0;
      notify(false);
    }
  });
}
